import {Component, forwardRef, Input, Output, EventEmitter} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'in-input-number',
    templateUrl: './inspark-input-number.component.html',
    styleUrls: ['./inspark-input-number.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InsparkInputNumberComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class InsparkInputNumberComponent implements ControlValueAccessor {
  @Input() name = null;
  @Input() autocomplete = true;
  @Input() label = null;
  @Input() required = false;
  @Input() error = null;
  @Input() size = 100000;
  @Input() maxlength = 100000;
  @Input() width = '';
  @Input() display = true;
  @Input() large = true;
  @Input() small = false;
  @Input() widget = false;
  @Input() forms = false;
  @Input() placeholder = '';
  @Input() id = null;
  @Input() testId = null;
  @Input() disabled: boolean;
  @Input() opacity = true;
  @Input() shadow = false;
  @Input() right = false;
  @Input() type = 'text';
  @Input() step: number;
  @Input() min: number;
  @Input() max: number;


  @Output() focus: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  value: string;

  /**
   * Write form value to the DOM element (model => view)
   */
  writeValue(value: any): void {
    this.value = value;
  }

  /**
   * Write form disabled state to the DOM element (model => view)
   */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * Update form when DOM element value changes (view => model)
   */
  registerOnChange(fn: any): void {
    // Store the provided function as an internal method.
    this.propagateChange = fn;
  }

  /**
   * Update form when DOM element is blurred (view => model)
   */
  registerOnTouched(fn: any): void {
    // Store the provided function as an internal method.
    this.onTouched = fn;
  }

  private propagateChange = (_: any) => {
  }

  clear() {
    this.value = '';
    this.propagateChange('');
    this.onClick.emit('');
  }

  onChange(_: any) {
    if (this.type === 'number') {
      this.propagateChange(+this.value);
    } else {
      this.propagateChange(this.value);
    }
  }

  private onTouched() {
  }


}
